export const statusPages = (state) => state.statusPage.statusPages;
export const statusPageHttpJobs = (state) => state.statusPage.statusPageHttpJobs;
